import type { AxiosError } from 'axios'
import type { UseGetCartParams } from './use-get-cart-query-config'
import type { CartItemsResponse } from '~/lib/services/api/cart'
import { TAG_TYPES } from '@lib/config'

import { useQuery, useQueryClient, useSuspenseQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { getUserCart } from '~/lib/services/api/cart'
import {
  getCartQueryConfig,

} from './use-get-cart-query-config'

export function useGetCartQuery(params?: UseGetCartParams) {
  return useQuery<CartItemsResponse, AxiosError>(getCartQueryConfig(params))
}

function useGetCart(params?: UseGetCartParams) {
  const queryClient = useQueryClient()

  // Listen for PARENT_FOCUS message from WordPress when parent tab gets focus
  useEffect(() => {
    if (typeof window !== 'undefined' && window.self !== window.top) {
      const handleMessage = (event: MessageEvent) => {
        if (event.data?.type === 'PARENT_FOCUS') {
          queryClient.refetchQueries({
            predicate: query => query.queryKey[0] === TAG_TYPES.CART,
          })
        }
      }

      window.addEventListener('message', handleMessage)
      return () => window.removeEventListener('message', handleMessage)
    }
  }, [queryClient])

  return useSuspenseQuery<CartItemsResponse, AxiosError>({
    ...getCartQueryConfig(params),
    queryFn: async () => {
      const res = await getUserCart(
        params?.location,
        params?.country,
        params?.island,
        params?.axiosConfig,
      )
      const cartData = res.data.data

      // Notify WordPress parent about cart update
      if (typeof window !== 'undefined' && window.self !== window.top) {
        window.parent.postMessage(
          {
            type: 'CART_ITEMS_SYNC',
            data: {
              items: cartData.items,
              itemCount: cartData.items?.length || 0,
              timestamp: Date.now(),
            },
          },
          '*',
        )
      }

      return cartData
    },
  })
}

export default useGetCart
